module.exports = __webpack_public_path__ + "img/2-1.eecbaf0a.png";